<template lang="pug">
    main#app(@mouseup="$eventBus.$emit('mouseup', $event)", @touchend="$eventBus.$emit('mouseup', $event)", @keyup.esc="$eventBus.$emit('keyup', false, 0)")
        Header
        router-view
        Footer
</template>

<script>
import Header from '@components/Header/Header.vue'
import Footer from '@components/Footer/Footer.vue'

export default {
    name: "app",
    components: {
        Header,
        Footer,
    }
}
</script>

<style lang="stylus" src="@templates/App/App.styl"></style>